import React from 'react';

// material-ui: theme, colors, icons
import {Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, Grid, MenuItem, InputLabel, Select, Stack } from '@mui/material/';
import AlertInfo from '../../dataObjects/AlertInfo';

interface AlertInfoDialogProps {
    isAlertInfoDialogOpen: boolean,
    alertInfo?: AlertInfo,
    closeAlertInfoDialog: () => void;
    confirmAction?: (confirm: boolean) => void;
}

const AlertInfoDialog = (props: AlertInfoDialogProps) => {

    const confirmAction = () => {
        if (props.confirmAction)
            props.confirmAction(true);
    }

    const rejectAction = () => {
        if (props.confirmAction)
            props.confirmAction(false);
    }

    return (
        <>
            {
                props.alertInfo &&
                <Dialog
                        open={props.isAlertInfoDialogOpen}
                        onClose={props.closeAlertInfoDialog}
                >
                    <DialogTitle>{props.alertInfo.title}</DialogTitle>
                    <DialogContent>
                        <Grid container>
                            <Stack direction="row" spacing={1} sx={{ marginTop: 1, width: '100%' }}>
                                    {
                                        props.alertInfo.type === 'success' &&
                                        <Alert severity="success">{props.alertInfo.errorMessage} {props.alertInfo.secondaryErrorMessage}</Alert>
                                    }
                                    {
                                        props.alertInfo.type === 'error' && 
                                        <Alert severity="error">{props.alertInfo.errorMessage} {props.alertInfo.secondaryErrorMessage}</Alert>
                                    }
                                    {
                                        props.alertInfo.type === 'info' &&
                                        <Alert severity="info">{props.alertInfo.errorMessage} {props.alertInfo.secondaryErrorMessage}</Alert>
                                    }  
                                    {
                                        props.alertInfo.type === 'warning' &&
                                        <Alert severity="warning">{props.alertInfo.errorMessage} {props.alertInfo.secondaryErrorMessage}</Alert>
                                    }
                                    {
                                        props.alertInfo.type === 'confirm' &&
                                        <Alert severity="info">{props.alertInfo.errorMessage} {props.alertInfo.secondaryErrorMessage}</Alert>
                                    }
                            </Stack>
                        </Grid>
                    </DialogContent>
                        <DialogActions>
                            {
                                props.alertInfo.type === 'warning' &&
                                <Button onClick={props.closeAlertInfoDialog}>Cancel</Button>
                            }
                            {
                                props.alertInfo.type === 'success' &&
                                <Button onClick={props.closeAlertInfoDialog}>OK</Button>
                            }
                            {
                                props.alertInfo.type === 'info' &&
                                <>
                                    <Button onClick={props.closeAlertInfoDialog} variant="contained" color="warning">Cancel</Button>
                                    <Button onClick={confirmAction} variant="contained" color="primary">{props.alertInfo.buttonLabel}</Button>
                                </>
                            }
                            {
                                props.alertInfo.type === 'error' &&
                                <Button onClick={props.closeAlertInfoDialog}>OK</Button>
                            }
                            {
                                props.alertInfo.type === 'warning' && props.alertInfo.buttonLabel && 
                                <Button onClick={confirmAction} variant="contained" color="error">{props.alertInfo.buttonLabel}</Button>
                            }
                            {
                                props.alertInfo.type === 'confirm' && props.alertInfo.buttonLabel &&
                                <>
                                    <Button onClick={confirmAction} variant="contained" color="primary">{props.alertInfo.buttonLabel}</Button>
                                    <Button onClick={rejectAction} variant="contained" color="error">No</Button>
                                </>
                            }
                    </DialogActions>
                </Dialog>
            }
            
        </>
    )

}

export default AlertInfoDialog;